import useFetchIntegrationPropertySettings from 'hooks/useFetchIntegrationPropertySettings';
import {
  IntegrationEnum,
  IntegrationStatus,
} from 'models/InternalIntegrationSetting';
import useAppUser from './useAppUser';

const usePaypal = (propertyUid: string) => {
  const { isEmployee } = useAppUser();

  const { data } = useFetchIntegrationPropertySettings({
    enumId: IntegrationEnum.PAYPAL,
    propertyUids: [propertyUid],
    enabled: isEmployee && !!propertyUid,
  });

  const propertySetting = data?.propertySettings?.find(
    (setting) => setting.propertyUid === propertyUid,
  );

  return propertySetting?.status === IntegrationStatus.ACTIVE;
};

export default usePaypal;
